<template>
   <v-layout aling-start>
      <v-flex>
         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :right="true"
            :bottom="true"
            :timeout="4000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <!-- ================= MODAL: PROGRAMAS DE LA SECCIÓN ================= -->
         <v-dialog v-model="dialogProgramas" max-width="560px" scrollable>
            <v-card>
               <v-card-title class="seccion-cabecera mb-0" style="border-radius: 0">
                  Programas de {{ tipoModal === 'SABATINO' ? 'Sabatinos' : 'Intensivo' }}
               </v-card-title>

               <v-card-text class="pt-4">
                  <div class="caption grey--text text--darken-1 mb-2">
                     Seleccione un programa y agréguelo a esta sección. Los programas
                     agregados se mostrarán cuando la fecha esté vigente. Marque
                     <strong>Exonerar mora</strong> para que un programa no cobre el
                     recargo por pago extemporáneo (${{ recargoIdiomas.toFixed(2) }});
                     esto no altera las fechas de apertura y cierre.
                  </div>

                  <!-- SELECTOR + AGREGAR -->
                  <div class="d-flex align-center">
                     <v-autocomplete
                        v-model="programaAAgregar"
                        :items="programasParaAgregar"
                        item-text="etiqueta"
                        item-value="programaId"
                        label="Buscar programa"
                        dense
                        outlined
                        hide-details
                        clearable
                        no-data-text="No hay programas disponibles"
                        class="mr-2"
                     />
                     <v-btn
                        color="primary"
                        :disabled="!programaAAgregar"
                        @click="agregarProgramaModal"
                     >
                        <v-icon left small>fas fa-plus</v-icon> Agregar
                     </v-btn>
                  </div>

                  <!-- LISTA DE ASIGNADOS -->
                  <div class="text-subtitle-2 mt-4 mb-1">
                     Programas asignados ({{ seleccionModal.length }})
                  </div>
                  <v-list dense class="asignados-lista">
                     <v-list-item
                        v-for="p in programasSeleccionadosModal"
                        :key="p.programaId"
                     >
                        <v-list-item-content>
                           <v-list-item-title>{{ p.nombre }}</v-list-item-title>
                           <v-list-item-subtitle>
                              {{ p.idioma }} · {{ formatHora(p.inicio) }} -
                              {{ formatHora(p.fin) }}
                           </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="mr-0">
                           <v-checkbox
                              :input-value="exoneracionModal.includes(p.programaId)"
                              label="Exonerar mora"
                              dense
                              hide-details
                              class="mt-0 pt-0 caption"
                              @change="toggleExoneracionModal(p.programaId, $event)"
                           />
                        </v-list-item-action>
                        <v-list-item-action>
                           <v-btn
                              icon
                              small
                              color="error"
                              @click="quitarProgramaModal(p.programaId)"
                           >
                              <v-icon small>fas fa-trash</v-icon>
                           </v-btn>
                        </v-list-item-action>
                     </v-list-item>
                     <v-list-item v-if="!seleccionModal.length">
                        <v-list-item-content>
                           <v-list-item-title class="grey--text">
                              Sin programas asignados
                           </v-list-item-title>
                        </v-list-item-content>
                     </v-list-item>
                  </v-list>
               </v-card-text>

               <v-divider></v-divider>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogProgramas = false">Cancelar</v-btn>
                  <v-btn
                     color="primary"
                     :loading="guardandoProgramas"
                     @click="guardarProgramasModal"
                  >
                     <v-icon left small>fas fa-save</v-icon> Guardar
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-container fluid>
            <v-layout
               wrap
               :style="
                  $vuetify.breakpoint.xlOnly
                     ? 'padding-right: 8%; padding-left: 8%'
                     : ''
               "
            >
               <!-- TÍTULO -->
               <v-flex xs12 text-center mb-6>
                  <span class="font-weight-medium text-h5">
                     Calendarización de módulos de inglés y francés
                  </span>
                  <div
                     v-if="!vista"
                     class="caption grey--text text--darken-1 mt-2"
                  >
                     Seleccione el apartado que desea configurar.
                  </div>
               </v-flex>

               <!-- VOLVER: solo dentro de un apartado -->
               <v-flex v-if="vista" xs12 mb-4>
                  <v-btn text color="primary" @click="vista = null">
                     <v-icon left small>fas fa-arrow-left</v-icon> Volver
                  </v-btn>
               </v-flex>

               <!-- ================= MENÚ ================= -->
               <!-- Los tres apartados se muestran de a uno para que la pantalla no
                    crezca demasiado; toda la lógica sigue viviendo en este mismo
                    componente y solo se alterna qué sección se dibuja. -->
               <v-flex v-if="!loading && !vista" xs12>
                  <v-container class="px-1" grid-list-md fluid>
                     <v-layout wrap justify-center>
                        <v-flex
                           v-for="opcion in opcionesMenu"
                           :key="opcion.vista"
                           xs12
                           sm6
                           md4
                        >
                           <v-layout align-center justify-center wrap>
                              <v-flex
                                 xs12
                                 :class="
                                    $vuetify.breakpoint.smAndUp ? 'px-8' : ''
                                 "
                              >
                                 <v-btn
                                    rounded
                                    color="primary"
                                    block
                                    height="60px"
                                    x-large
                                    @click="vista = opcion.vista"
                                 >
                                    <v-icon left>{{ opcion.icono }}</v-icon>
                                    {{ opcion.titulo }}
                                 </v-btn>
                              </v-flex>
                              <v-flex xs12 class="text-center mt-4 mb-8">
                                 <div class="body-2 grey--text text--darken-1">
                                    {{ opcion.descripcion }}
                                 </div>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-flex>

               <!-- CARGANDO -->
               <v-flex
                  v-if="loading"
                  my-8
                  xs12
                  d-flex
                  justify-center
                  align-center
               >
                  <span
                     class="colorPrimary font-weight-medium mr-2"
                     style="font-size: 24px"
                  >
                     Cargando...
                  </span>
                  <i class="ml-2 fas fa-sync-alt fa-3x fa-spin colorPrimary"></i>
               </v-flex>

               <template v-else>
                  <!-- ================= SABATINOS ================= -->
                  <v-flex v-if="vista === 'SABATINO'" xs12>
                     <!-- CABECERA DE SECCIÓN (abre el modal de programas) -->
                     <div
                        class="seccion-cabecera seccion-cabecera--btn"
                        role="button"
                        @click="abrirModalProgramas('SABATINO')"
                     >
                        SABATINOS
                        <v-icon color="white" small class="ml-2">fas fa-cog</v-icon>
                     </div>

                     <!-- CONFIGURACIÓN ADMINISTRATIVA DE FILAS -->
                     <v-card outlined class="pa-3 mb-4">
                        <div class="caption grey--text text--darken-1 mb-2">
                           <v-icon x-small color="primary" class="mr-1">fas fa-calendar-alt</v-icon>
                           Configuración de inscripción (fechas)
                        </div>
                        <v-simple-table dense class="entradas-tabla">
                           <thead>
                              <tr>
                                 <th style="width: 70px">Entrada</th>
                                 <th>Fecha de inicio de inscripción</th>
                                 <th>Fecha fin de inscripción</th>
                                 <th style="width: 48px"></th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(e, i) in entradasSabatinos"
                                 :key="'sab-' + i"
                              >
                                 <td class="text-center font-weight-bold colorPrimary">
                                    {{ i + 1 }}
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.inicio"
                                       label=""
                                       min="2020-01-01"
                                       picker-only
                                       @updateFecha="e.inicio = $event"
                                    />
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.fin"
                                       label=""
                                       :min="e.inicio || '2020-01-01'"
                                       picker-only
                                       @updateFecha="e.fin = $event"
                                    />
                                 </td>
                                 <td class="text-center">
                                    <v-btn
                                       icon
                                       small
                                       color="error"
                                       @click="eliminarEntrada(entradasSabatinos, i)"
                                    >
                                       <v-icon small>fas fa-trash</v-icon>
                                    </v-btn>
                                 </td>
                              </tr>
                              <tr v-if="!entradasSabatinos.length">
                                 <td colspan="4" class="text-center grey--text">
                                    Sin entradas. Agregue una fila.
                                 </td>
                              </tr>
                           </tbody>
                        </v-simple-table>
                        <v-btn
                           small
                           color="primary"
                           text
                           class="mt-2"
                           @click="agregarEntrada(entradasSabatinos)"
                        >
                           <v-icon left small>fas fa-plus</v-icon> Agregar fila
                        </v-btn>
                        <v-btn
                           small
                           color="primary"
                           class="mt-2 ml-2"
                           :loading="guardandoSabatino"
                           @click="guardar('SABATINO')"
                        >
                           <v-icon left small>fas fa-save</v-icon> Guardar
                        </v-btn>
                     </v-card>

                     <!-- ESTADO -->
                     <div class="text-center mb-2">
                        <v-chip :color="estadoSabatinos.color" dark>
                           <v-icon left small>{{ estadoSabatinos.icono }}</v-icon>
                           {{ estadoSabatinos.label }}
                        </v-chip>
                     </div>

                     <!-- ALERTA DE RECARGO -->
                     <v-alert
                        v-if="estadoSabatinos.aplicaRecargo"
                        type="warning"
                        dense
                        text
                        class="mb-2"
                     >
                        Inscripción con Recargo — se aplicará un cargo adicional de
                        <strong>${{ recargoIdiomas.toFixed(2) }}</strong>
                     </v-alert>

                     <!-- PROGRAMAS / CERRADO -->
                     <template v-if="estadoSabatinos.visible">
                        <div class="text-h6 text-center mt-4">
                           Programas de idiomas que aplican:
                        </div>
                        <v-card class="mx-auto font-weight-medium" width="320px" flat>
                           <v-list-item
                              v-for="p in sabatinos"
                              :key="p.programaId"
                              two-line
                           >
                              <v-icon left class="colorPrimary" style="font-size: 10px"
                                 >fas fa-circle</v-icon
                              >
                              <v-list-item-content>
                                 <v-list-item-title>{{ p.nombre }}</v-list-item-title>
                                 <v-list-item-subtitle>
                                    {{ p.idioma }} · {{ formatHora(p.inicio) }} -
                                    {{ formatHora(p.fin) }}
                                 </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-chip
                                 v-if="programasExoneradosIds.includes(p.programaId)"
                                 x-small
                                 color="success"
                                 outlined
                              >
                                 Sin mora
                              </v-chip>
                           </v-list-item>
                           <v-list-item v-if="!sabatinos.length">
                              <v-list-item-content>
                                 <v-list-item-title class="grey--text">
                                    Sin programas
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                        </v-card>
                     </template>
                     <v-alert v-else type="info" text dense class="mt-4 text-center">
                        Módulos cerrados temporalmente
                     </v-alert>
                  </v-flex>

                  <!-- DIVISOR -->
                  <v-divider
                     v-if="$vuetify.breakpoint.mdAndUp"
                     vertical
                  ></v-divider>

                  <!-- ================= INTENSIVO ================= -->
                  <v-flex v-if="vista === 'INTENSIVO'" xs12>
                     <!-- CABECERA DE SECCIÓN (abre el modal de programas) -->
                     <div
                        class="seccion-cabecera seccion-cabecera--btn"
                        role="button"
                        @click="abrirModalProgramas('INTENSIVO')"
                     >
                        INTENSIVO
                        <v-icon color="white" small class="ml-2">fas fa-cog</v-icon>
                     </div>

                     <!-- CONFIGURACIÓN ADMINISTRATIVA DE FILAS -->
                     <v-card outlined class="pa-3 mb-4">
                        <div class="caption grey--text text--darken-1 mb-2">
                           <v-icon x-small color="primary" class="mr-1">fas fa-calendar-alt</v-icon>
                           Configuración de inscripción (fechas)
                        </div>
                        <v-simple-table dense class="entradas-tabla">
                           <thead>
                              <tr>
                                 <th style="width: 70px">Entrada</th>
                                 <th>Fecha de inicio de inscripción</th>
                                 <th>Fecha fin de inscripción</th>
                                 <th style="width: 48px"></th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr
                                 v-for="(e, i) in entradasIntensivo"
                                 :key="'int-' + i"
                              >
                                 <td class="text-center font-weight-bold colorPrimary">
                                    {{ i + 1 }}
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.inicio"
                                       label=""
                                       min="2020-01-01"
                                       picker-only
                                       @updateFecha="e.inicio = $event"
                                    />
                                 </td>
                                 <td>
                                    <CustomDatePicker
                                       :date="e.fin"
                                       label=""
                                       :min="e.inicio || '2020-01-01'"
                                       picker-only
                                       @updateFecha="e.fin = $event"
                                    />
                                 </td>
                                 <td class="text-center">
                                    <v-btn
                                       icon
                                       small
                                       color="error"
                                       @click="eliminarEntrada(entradasIntensivo, i)"
                                    >
                                       <v-icon small>fas fa-trash</v-icon>
                                    </v-btn>
                                 </td>
                              </tr>
                              <tr v-if="!entradasIntensivo.length">
                                 <td colspan="4" class="text-center grey--text">
                                    Sin entradas. Agregue una fila.
                                 </td>
                              </tr>
                           </tbody>
                        </v-simple-table>
                        <v-btn
                           small
                           color="primary"
                           text
                           class="mt-2"
                           @click="agregarEntrada(entradasIntensivo)"
                        >
                           <v-icon left small>fas fa-plus</v-icon> Agregar fila
                        </v-btn>
                        <v-btn
                           small
                           color="primary"
                           class="mt-2 ml-2"
                           :loading="guardandoIntensivo"
                           @click="guardar('INTENSIVO')"
                        >
                           <v-icon left small>fas fa-save</v-icon> Guardar
                        </v-btn>
                     </v-card>

                     <!-- ESTADO -->
                     <div class="text-center mb-2">
                        <v-chip :color="estadoIntensivo.color" dark>
                           <v-icon left small>{{ estadoIntensivo.icono }}</v-icon>
                           {{ estadoIntensivo.label }}
                        </v-chip>
                     </div>

                     <!-- ALERTA DE RECARGO -->
                     <v-alert
                        v-if="estadoIntensivo.aplicaRecargo"
                        type="warning"
                        dense
                        text
                        class="mb-2"
                     >
                        Inscripción con Recargo — se aplicará un cargo adicional de
                        <strong>${{ recargoIdiomas.toFixed(2) }}</strong>
                     </v-alert>

                     <!-- PROGRAMAS / CERRADO -->
                     <template v-if="estadoIntensivo.visible">
                        <div class="text-h6 text-center mt-4">
                           Programas de idiomas que aplican:
                        </div>
                        <v-card class="mx-auto font-weight-medium" width="320px" flat>
                           <v-list-item
                              v-for="p in intensivos"
                              :key="p.programaId"
                              two-line
                           >
                              <v-icon left class="colorPrimary" style="font-size: 10px"
                                 >fas fa-circle</v-icon
                              >
                              <v-list-item-content>
                                 <v-list-item-title>{{ p.nombre }}</v-list-item-title>
                                 <v-list-item-subtitle>
                                    {{ p.idioma }} · {{ formatHora(p.inicio) }} -
                                    {{ formatHora(p.fin) }}
                                 </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-chip
                                 v-if="programasExoneradosIds.includes(p.programaId)"
                                 x-small
                                 color="success"
                                 outlined
                              >
                                 Sin mora
                              </v-chip>
                           </v-list-item>
                           <v-list-item v-if="!intensivos.length">
                              <v-list-item-content>
                                 <v-list-item-title class="grey--text">
                                    Sin programas
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                        </v-card>
                     </template>
                     <v-alert v-else type="info" text dense class="mt-4 text-center">
                        Módulos cerrados temporalmente
                     </v-alert>
                  </v-flex>

                  <!-- ================= IDIOMAS EXTRAORDINARIOS ================= -->
                  <v-flex v-if="vista === 'EXTRA'" xs12>
                     <div class="seccion-cabecera">IDIOMAS EXTRAORDINARIOS</div>

                     <v-card outlined class="pa-3">
                        <div class="caption grey--text text--darken-1 mb-3">
                           <v-icon x-small color="primary" class="mr-1">
                              fas fa-user-check
                           </v-icon>
                           Carnets autorizados a inscribir y pagar aunque segun
                           modulos esté fuera de las fechas con recargo, en
                           Colecturía Digital y Externa. El permiso rige entre
                           las fechas de habilitación y desactivación, ambas
                           incluidas y obligatorias. Fuera de ese rango el
                           alumno vuelve a regirse por la calendarización
                           normal.
                           <br />
                           Si se autoriza a un alumno externo por su carnet, al
                           registrarse en el módulo de idiomas el sistema enlaza
                           por sí solo el código que se le asigne, y la
                           autorización sigue valiendo sin necesidad de volver a
                           cargarla.
                        </div>

                        <!-- ALTA -->
                        <v-form ref="formExtra" v-model="validExtra">
                           <v-layout wrap align-center>
                              <v-flex xs12 sm3 class="pr-2">
                                 <v-text-field
                                    v-model="extraCarnet"
                                    label="Carnet"
                                    placeholder="2021-CU-501"
                                    :rules="[(v) => !!v || 'El carnet es obligatorio']"
                                    maxlength="16"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    @keyup.enter="agregarExtraordinario"
                                 />
                              </v-flex>
                              <v-flex xs12 sm3 class="pr-2">
                                 <v-select
                                    v-model="extraTipo"
                                    :items="['SABATINO', 'INTENSIVO']"
                                    label="MODULO"
                                    dense
                                    outlined
                                    hide-details="auto"
                                 />
                              </v-flex>
                              <v-flex xs12 sm3 class="pr-2">
                                 <CustomDatePicker
                                    :date="extraFechaHabilitacion"
                                    label="Habilitación *"
                                    min="2020-01-01"
                                    picker-only
                                    clearable
                                    @updateFecha="extraFechaHabilitacion = $event"
                                 />
                              </v-flex>
                              <v-flex xs12 sm3>
                                 <CustomDatePicker
                                    :date="extraFechaDesactivacion"
                                    label="Desactivación *"
                                    :min="extraFechaHabilitacion || '2020-01-01'"
                                    picker-only
                                    clearable
                                    @updateFecha="extraFechaDesactivacion = $event"
                                 />
                              </v-flex>
                              <v-flex xs12 sm8 class="pr-2">
                                 <v-checkbox
                                    v-model="extraAplicaRecargo"
                                    label="Aplicar Recargo"
                                    dense
                                    hide-details
                                    class="mt-0"
                                 />
                              </v-flex>
                              <v-flex xs12 sm4>
                                 <v-btn
                                    color="primary"
                                    block
                                    :loading="guardandoExtra"
                                    @click="agregarExtraordinario"
                                 >
                                    <v-icon left small>fas fa-plus</v-icon> Agregar
                                 </v-btn>
                              </v-flex>
                           </v-layout>
                        </v-form>

                        <!-- LISTA -->
                        <v-simple-table dense class="entradas-tabla mt-4">
                           <thead>
                              <tr>
                                 <th style="width: 150px">Carnet</th>
                                 <!-- Lo anota el procedimiento de registro de idiomas,
                                      no se captura a mano. -->
                                 <th style="width: 150px">Código de idiomas</th>
                                 <th style="width: 120px">Modulo</th>
                                 <th>Recargo</th>
                                 <th style="width: 120px">Habilitación</th>
                                 <th style="width: 120px">Desactivación</th>
                                 <th style="width: 110px">Estado</th>
                                 <th style="width: 120px">Autorizado el</th>
                                 <th style="width: 48px"></th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="e in extraordinarios" :key="e.id">
                                 <td class="font-weight-bold colorPrimary">
                                    {{ e.carnet }}
                                 </td>
                                 <td class="caption">
                                    <span
                                       v-if="e.carnetIdiomas"
                                       class="font-weight-medium colorPrimary"
                                    >
                                       {{ e.carnetIdiomas }}
                                    </span>
                                    <span v-else class="grey--text">
                                       Sin registrar
                                    </span>
                                 </td>
                                 <td>{{ e.tipo }}</td>
                                 <td>
                                    <v-chip
                                       x-small
                                       dark
                                       :color="e.aplicaRecargo ? 'orange darken-2' : 'success'"
                                    >
                                       {{ e.aplicaRecargo ? 'Con recargo' : 'Sin recargo' }}
                                    </v-chip>
                                 </td>
                                 <td class="caption">
                                    {{ e.fechaHabilitacion || '—' }}
                                 </td>
                                 <td class="caption">
                                    {{ e.fechaDesactivacion || '—' }}
                                 </td>
                                 <td>
                                    <v-chip
                                       x-small
                                       dark
                                       :color="e.vigente ? 'success' : 'grey'"
                                    >
                                       {{ e.vigente ? 'Vigente' : 'Fuera de fecha' }}
                                    </v-chip>
                                 </td>
                                 <td class="caption">{{ e.fechaRegistro }}</td>
                                 <td class="text-center">
                                    <v-btn
                                       icon
                                       small
                                       color="error"
                                       :loading="quitandoExtraId === e.id"
                                       @click="quitarExtraordinario(e)"
                                    >
                                       <v-icon small>fas fa-trash</v-icon>
                                    </v-btn>
                                 </td>
                              </tr>
                              <tr v-if="!extraordinarios.length">
                                 <td colspan="9" class="text-center grey--text">
                                    No hay carnets autorizados.
                                 </td>
                              </tr>
                           </tbody>
                        </v-simple-table>
                     </v-card>
                  </v-flex>
               </template>
            </v-layout>
         </v-container>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers'

const CustomDatePicker = () => import('./custom/CustomDatePicker')

export default {
   name: 'CalendarizacionModulos',
   components: {
      CustomDatePicker
   },
   computed: {
      ...authComputed,
      // Solo programas de inglés (2) y francés (6)
      programasIdiomas() {
         return this.programas.filter(
            (p) => p.idiomaId === 2 || p.idiomaId === 6
         )
      },
      // Programas asignados manualmente a cada sección (por ID)
      sabatinos() {
         return this.programasIdiomas.filter((p) =>
            this.programasSabatinoIds.includes(p.programaId)
         )
      },
      intensivos() {
         return this.programasIdiomas.filter((p) =>
            this.programasIntensivoIds.includes(p.programaId)
         )
      },
      // --- Modal de programas ---
      // Programas ya seleccionados en el modal (para listarlos)
      programasSeleccionadosModal() {
         return this.programasIdiomas.filter((p) =>
            this.seleccionModal.includes(p.programaId)
         )
      },
      // Programas que aún se pueden agregar (no seleccionados en el modal)
      programasParaAgregar() {
         return this.programasIdiomas
            .filter((p) => !this.seleccionModal.includes(p.programaId))
            .map((p) => ({
               programaId: p.programaId,
               etiqueta: `${p.nombre} — ${p.idioma}`
            }))
      },
      // Estado automático de cada sección según sus entradas de fechas
      estadoSabatinos() {
         return this.calcularEstadoEntradas(this.entradasSabatinos)
      },
      estadoIntensivo() {
         return this.calcularEstadoEntradas(this.entradasIntensivo)
      }
   },
   data: () => ({
      snackbar: false,
      snackText: '',
      snackColor: 'primary',
      loading: false,
      programas: [],

      // Apartado abierto: null = menú; 'SABATINO' | 'INTENSIVO' | 'EXTRA'
      vista: null,
      // Apartados cuyos datos ya se pidieron, para no repetir la consulta al volver
      cargado: {},
      opcionesMenu: [
         {
            vista: 'SABATINO',
            titulo: 'Sabatinos',
            icono: 'fas fa-calendar-week',
            descripcion:
               'Fechas de inscripción y programas de la sección sabatina.'
         },
         {
            vista: 'INTENSIVO',
            titulo: 'Intensivos',
            icono: 'fas fa-calendar-day',
            descripcion:
               'Fechas de inscripción y programas de la sección intensiva.'
         },
         {
            vista: 'EXTRA',
            titulo: 'Idiomas extraordinarios',
            icono: 'fas fa-user-check',
            descripcion:
               'Carnets autorizados a pagar aunque su sección esté cerrada.'
         }
      ],


      // Recargo por pago tardío de módulos de idiomas.
      // Valor encontrado en el backend: Constante.PagoExtraIdiomas = 5 ($5.00).
      recargoIdiomas: 5.0,
      // Días de gracia (prórroga con recargo) posteriores a la Fecha Fin.
      diasGracia: 5,

      // Entradas (períodos) por sección. Cada una: { inicio: 'yyyy-MM-dd', fin: 'yyyy-MM-dd' }
      entradasSabatinos: [{ inicio: '', fin: '' }],
      entradasIntensivo: [{ inicio: '', fin: '' }],
      guardandoSabatino: false,
      guardandoIntensivo: false,

      // Programas asignados a cada sección (IDs), gestionados desde el modal
      programasSabatinoIds: [],
      programasIntensivoIds: [],
      // Programas exonerados del recargo por extemporaneidad (IDs, ambas secciones)
      programasExoneradosIds: [],

      // Idiomas extraordinarios: carnets habilitados fuera del período
      extraordinarios: [],
      extraCarnet: '',
      extraTipo: 'SABATINO',
      extraAplicaRecargo: false,
      // Ventana de vigencia. Vacías = sin límite por ese lado.
      extraFechaHabilitacion: null,
      extraFechaDesactivacion: null,
      validExtra: false,
      guardandoExtra: false,
      quitandoExtraId: null,

      // Estado del modal de programas
      dialogProgramas: false,
      tipoModal: '',
      seleccionModal: [],
      exoneracionModal: [],
      programaAAgregar: null,
      guardandoProgramas: false
   }),
   created() {
      // Validando acceso al componente (permiso 27 del módulo Colecturía Digital)
      // No se carga nada acá: cada apartado pide sus datos al abrirse (ver watch
      // de `vista`), así el menú aparece de inmediato.
      if (!this.permController(27, 'ver')) {
         this.$router.push({ name: 'inicio' })
      }
   },
   watch: {
      /**
       * Carga diferida: los datos de cada apartado se piden la primera vez que se
       * entra, no al abrir la pantalla. `cargado` evita repetir la petición al
       * volver al mismo apartado.
       */
      vista(val) {
         if (!val || this.cargado[val]) return

         if (val === 'SABATINO' || val === 'INTENSIVO') {
            // Ambas secciones comparten los mismos tres orígenes de datos.
            this.listarProgramas()
            this.cargarEntradas()
            this.cargarProgramasAsignados()
            this.$set(this.cargado, 'SABATINO', true)
            this.$set(this.cargado, 'INTENSIVO', true)
         } else if (val === 'EXTRA') {
            this.cargarExtraordinarios()
            this.$set(this.cargado, 'EXTRA', true)
         }
      }
   },
   methods: {
      listarProgramas() {
         this.loading = true
         axios
            .get('api/ProgramaIdioma?activo=true')
            .then((response) => {
               this.programas = response.data
            })
            .catch(() => {
               this.showSnack('Error al obtener los programas.', 'snackError')
            })
            .finally(() => {
               this.loading = false
            })
      },
      // --- Carga y guardado de entradas ---
      cargarEntradas() {
         axios
            .get('api/CalendarizacionModulos')
            .then((r) => {
               const map = (arr) =>
                  arr && arr.length
                     ? arr.map((e) => ({ inicio: e.fechaInicio, fin: e.fechaFin }))
                     : [{ inicio: '', fin: '' }]
               this.entradasSabatinos = map(r.data.sabatino)
               this.entradasIntensivo = map(r.data.intensivo)
            })
            .catch(() => {
               this.showSnack('Error al cargar la calendarización.', 'snackError')
            })
      },
      guardar(tipo) {
         const arr =
            tipo === 'SABATINO' ? this.entradasSabatinos : this.entradasIntensivo

         // Validación: la fecha fin no puede ser menor que la fecha de inicio
         const invalida = arr.find(
            (e) =>
               e.inicio &&
               e.fin &&
               e.fin.toString().substring(0, 10) <
                  e.inicio.toString().substring(0, 10)
         )
         if (invalida) {
            this.showSnack(
               'La fecha fin no puede ser menor que la fecha de inicio.',
               'snackError'
            )
            return
         }

         const entradas = arr
            .filter((e) => e.inicio && e.fin)
            .map((e) => ({ fechaInicio: e.inicio, fechaFin: e.fin }))
         const flag =
            tipo === 'SABATINO' ? 'guardandoSabatino' : 'guardandoIntensivo'

         this[flag] = true
         axios
            .put('api/CalendarizacionModulos', { tipo, entradas })
            .then(() => {
               this.showSnack(
                  'Calendarización guardada correctamente.',
                  'snackSuccess'
               )
            })
            .catch((error) => {
               const msg =
                  error.response && typeof error.response.data === 'string'
                     ? error.response.data
                     : 'Error al guardar la calendarización.'
               this.showSnack(msg, 'snackError')
            })
            .finally(() => {
               this[flag] = false
            })
      },
      // --- Idiomas extraordinarios ---
      cargarExtraordinarios() {
         axios
            .get('api/CalendarizacionModulos/extraordinarios')
            .then((r) => {
               this.extraordinarios = r.data || []
            })
            .catch(() => {
               this.showSnack(
                  'Error al cargar los idiomas extraordinarios.',
                  'snackError'
               )
            })
      },
      agregarExtraordinario() {
         if (!this.$refs.formExtra.validate()) return

         if (!this.extraFechaHabilitacion || !this.extraFechaDesactivacion) {
            this.showSnack(
               'Debe indicar la fecha de habilitación y la de desactivación.',
               'snackError'
            )
            return
         }

         this.guardandoExtra = true
         axios
            .post('api/CalendarizacionModulos/extraordinarios', {
               carnet: this.extraCarnet.trim().toUpperCase(),
               tipo: this.extraTipo,
               aplicaRecargo: this.extraAplicaRecargo,
               fechaHabilitacion: this.extraFechaHabilitacion || null,
               fechaDesactivacion: this.extraFechaDesactivacion || null
            })
            .then(() => {
               this.showSnack('Carnet autorizado correctamente.', 'snackSuccess')
               // Se conserva la sección y el criterio de recargo, que al cargar varios
               // seguidos suelen repetirse; el carnet y las fechas se limpian para no
               // arrastrar por descuido la ventana de vigencia del alumno anterior.
               this.extraCarnet = ''
               this.extraFechaHabilitacion = null
               this.extraFechaDesactivacion = null
               this.$refs.formExtra.resetValidation()
               this.cargarExtraordinarios()
            })
            .catch((error) => {
               const msg =
                  error.response && typeof error.response.data === 'string'
                     ? error.response.data
                     : 'No se pudo autorizar el carnet.'
               this.showSnack(msg, 'snackError')
            })
            .finally(() => {
               this.guardandoExtra = false
            })
      },
      quitarExtraordinario(permiso) {
         this.quitandoExtraId = permiso.id
         axios
            .delete('api/CalendarizacionModulos/extraordinarios/' + permiso.id)
            .then(() => {
               this.showSnack('Permiso quitado.', 'snackSuccess')
               this.cargarExtraordinarios()
            })
            .catch(() => {
               this.showSnack('No se pudo quitar el permiso.', 'snackError')
            })
            .finally(() => {
               this.quitandoExtraId = null
            })
      },
      // --- Programas asignados a cada sección ---
      cargarProgramasAsignados() {
         axios
            .get('api/CalendarizacionModulos/programas')
            .then((r) => {
               this.programasSabatinoIds = r.data.sabatino || []
               this.programasIntensivoIds = r.data.intensivo || []
               this.programasExoneradosIds = r.data.exonerados || []
            })
            .catch(() => {
               this.showSnack(
                  'Error al cargar los programas asignados.',
                  'snackError'
               )
            })
      },
      abrirModalProgramas(tipo) {
         this.tipoModal = tipo
         this.seleccionModal =
            tipo === 'SABATINO'
               ? [...this.programasSabatinoIds]
               : [...this.programasIntensivoIds]
         // Solo las exoneraciones de los programas de esta sección
         this.exoneracionModal = this.programasExoneradosIds.filter((id) =>
            this.seleccionModal.includes(id)
         )
         this.programaAAgregar = null
         this.dialogProgramas = true
      },
      toggleExoneracionModal(programaId, valor) {
         if (valor) {
            if (!this.exoneracionModal.includes(programaId)) {
               this.exoneracionModal.push(programaId)
            }
         } else {
            this.exoneracionModal = this.exoneracionModal.filter(
               (id) => id !== programaId
            )
         }
      },
      agregarProgramaModal() {
         if (
            this.programaAAgregar &&
            !this.seleccionModal.includes(this.programaAAgregar)
         ) {
            this.seleccionModal.push(this.programaAAgregar)
         }
         this.programaAAgregar = null
      },
      quitarProgramaModal(programaId) {
         this.seleccionModal = this.seleccionModal.filter(
            (id) => id !== programaId
         )
         // Al salir de la sección, el programa deja de estar exonerado
         this.exoneracionModal = this.exoneracionModal.filter(
            (id) => id !== programaId
         )
      },
      guardarProgramasModal() {
         this.guardandoProgramas = true
         axios
            .put('api/CalendarizacionModulos/programas', {
               tipo: this.tipoModal,
               programaIds: this.seleccionModal,
               exoneradosIds: this.exoneracionModal
            })
            .then(() => {
               this.showSnack('Programas guardados correctamente.', 'snackSuccess')
               this.dialogProgramas = false
               // Recargar ambas secciones: la exclusividad puede haber quitado
               // programas de la otra sección.
               this.cargarProgramasAsignados()
            })
            .catch((error) => {
               const msg =
                  error.response && typeof error.response.data === 'string'
                     ? error.response.data
                     : 'Error al guardar los programas.'
               this.showSnack(msg, 'snackError')
            })
            .finally(() => {
               this.guardandoProgramas = false
            })
      },
      // --- Manejo de filas/entradas ---
      agregarEntrada(entradas) {
         entradas.push({ inicio: '', fin: '' })
      },
      eliminarEntrada(entradas, index) {
         entradas.splice(index, 1)
      },
      // --- Motor de automatización ---
      // Evalúa la fecha de hoy contra todas las entradas de la sección:
      //   abierto (dentro del período) > recargo (5 días de gracia) > cerrado.
      calcularEstadoEntradas(entradas) {
         const validas = entradas
            .map((e) => ({
               inicio: this.parseFecha(e.inicio),
               fin: this.parseFecha(e.fin)
            }))
            .filter((e) => e.inicio && e.fin)

         if (!validas.length) {
            return {
               codigo: 'SIN_CONFIG',
               label: 'Sin fechas configuradas',
               color: 'grey',
               icono: 'fas fa-question-circle',
               visible: false,
               aplicaRecargo: false
            }
         }

         const hoy = this.hoySoloFecha()
         let enRecargo = false

         for (const e of validas) {
            // Período normal: entre Fecha de Inicio y Fecha Fin (inclusive)
            if (hoy >= e.inicio && hoy <= e.fin) {
               return {
                  codigo: 'ABIERTO',
                  label: 'Inscripción abierta',
                  color: 'success',
                  icono: 'fas fa-check-circle',
                  visible: true,
                  aplicaRecargo: false
               }
            }
            // Período de recargo: 5 días posteriores a la Fecha Fin
            const finGracia = new Date(e.fin)
            finGracia.setDate(finGracia.getDate() + this.diasGracia)
            if (hoy > e.fin && hoy <= finGracia) {
               enRecargo = true
            }
         }

         if (enRecargo) {
            return {
               codigo: 'RECARGO',
               label: 'Inscripción con Recargo',
               color: 'warning',
               icono: 'fas fa-exclamation-triangle',
               visible: true,
               aplicaRecargo: true
            }
         }

         // Fuera de todo período y de la prórroga -> cerrado
         return {
            codigo: 'CERRADO',
            label: 'Módulos cerrados temporalmente',
            color: 'error',
            icono: 'fas fa-times-circle',
            visible: false,
            aplicaRecargo: false
         }
      },
      // Fecha de hoy sin componente de hora (para comparar solo por día)
      hoySoloFecha() {
         const d = new Date()
         return new Date(d.getFullYear(), d.getMonth(), d.getDate())
      },
      // Convierte "yyyy-MM-dd" a Date local a medianoche
      parseFecha(str) {
         if (!str) return null
         const p = str.toString().substring(0, 10).split('-')
         if (p.length === 3 && p[0].length === 4) {
            return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]))
         }
         return null
      },
      // Convierte "HH:mm:ss" -> "HH:mm"
      formatHora(hora) {
         if (!hora) return ''
         return hora.toString().substring(0, 5)
      },
      showSnack(text, color) {
         this.snackText = text
         this.snackColor = color
         this.snackbar = true
      }
   }
}
</script>

<style scoped>
.colorPrimary {
   color: var(--v-primary-base) !important;
}
.seccion-cabecera {
   background: var(--v-primary-base);
   color: #fff;
   font-weight: 700;
   letter-spacing: 1px;
   text-align: center;
   padding: 12px;
   border-radius: 30px;
   font-size: 20px;
   margin-bottom: 16px;
}
.entradas-tabla >>> td,
.entradas-tabla >>> th {
   padding: 4px 8px !important;
}
.seccion-cabecera--btn {
   cursor: pointer;
   transition: filter 0.15s ease, box-shadow 0.15s ease;
}
.seccion-cabecera--btn:hover {
   filter: brightness(1.08);
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.asignados-lista {
   max-height: 260px;
   overflow-y: auto;
}
</style>
